import { useCheckoutContext } from '../index'

export const useOrderDocument = () => {
  return useCheckoutContext().orderDocumentResult
}
